module.exports = __webpack_public_path__ + "img/1-14.65f5d561.png";